import React from 'react'; 
import NavigationHeader from '../components/navigationHeader';
import LoadRealTimeCompoent from "./loadrealtimecompoents"
import RcTooltip from 'rc-tooltip';
import {getLatestEnvironmentList,addUserTracking,deleteUserTracking} from '../utils/realtimeEventHandle'
import { v4 as uuidv4 } from 'uuid'; // For generating unique IDs
import {getTeamId,getUserId} from '../utils/common_utils'
import NoDataComponent from "./noDataComponent";
import Load from '../components/loadAction';
//import {IS_NONE_CHECK} from "../utils/constant";
import DrxReportFullScreen from "../monitor/components/dqReportFullScreen"

// import AiAssistant from '../components/ai-assistant';
// import { useLocation } from "react-router-dom";
//import {getFeatureAccess} from "../utils/common_utils"

// import $ from'jquery'

export default class RealTime extends React.Component {

  constructor(props) {
    super(props);
    const redirectData = props.location?.state?.data;
    const redirectTab = redirectData?.type;
    const redirectEnvId = redirectData?.env_id;
    const persistedTab = sessionStorage.getItem("realtimeSelectedTab");
    const initialTab = persistedTab === "PIPELINE" || persistedTab === "VERTICAL" || persistedTab === "DQ"
      ? persistedTab
      : redirectData?.menu_type === "VERTICAL"
        ? "VERTICAL"
        : redirectTab === "PIPELINE" || redirectTab === "DQ"
          ? redirectTab
          : "DQ";
    let { data } = props.location?.state || {};
    
    // Ignore incident redirect payload on reload or back/forward navigation
    if (props.location?.action === "POP") {
      data = null;
    }

    this.state = {
      // Apply an incident redirect before the initial environment request.  Using
      // a local value in render leaves the state (and therefore the API request)
      // on the DQ tab.
      selectedTab: initialTab,
      // selectedTab:"PIPELINE",
      selectedEnvName:"",
      selectedEnvId: redirectEnvId !== undefined && redirectEnvId !== null ? Number(redirectEnvId) : "",
      envList:[],
      browserSessionId: null,
      browserTabId: null,
      teamId:getTeamId(),
      userId:getUserId(),
      errorOccurred: false,
      noData:true,
      loader : true,
      isDrxReportFullscreenMode:false,
      redirectData: data,
      incidentData: data,
    }
    this.handleTabSelection = this.handleTabSelection.bind(this);
    this.callbackEnvironemnt = this.callbackEnvironemnt.bind(this);
    this.closedrxReportfullscreen = this.closedrxReportfullscreen.bind(this);
    this.drxReport = this.drxReport.bind(this);

    // const { location } = this.props;
    // const { data } = location.state || {};
    // alert(JSON.stringify(data));

  }

  getLatestEnvironmentResponse(){
    let requestParams = {
        // "tab_type": 1, // DQ Tab
        "tenant_id":this.state.teamId, // Team Id
        "user_id":this.state.userId
    }
    if(this.state.selectedTab === "PIPELINE"){
      requestParams["tab_type"] = 3
    }
    else if(this.state.selectedTab === "DQ"){
            requestParams["tab_type"] = 1

    }
      else if(this.state.selectedTab === "VERTICAL"){
            requestParams["tab_type"] = 4

    }
    return getLatestEnvironmentList(requestParams);
  }
  getPipelineLatestEnvironmentResponse(){
    let requestParams = {
        "tab_type": 3, // DQ Tab
        "tenant_id":this.state.teamId, // Team Id
        "user_id":this.state.userId
    }
    return getLatestEnvironmentList(requestParams);
  }

  async componentDidMount() {
       document.body.style.overflow = "hidden";
    // Handle session ID - persists until browser is closed
        let existingSessionId = sessionStorage.getItem("browserSessionId");
        let sessionId;
        sessionId = existingSessionId
        if (!existingSessionId) {
          const newSessionId = uuidv4();
          sessionId = newSessionId
          sessionStorage.setItem("browserSessionId", newSessionId);
          this.setState({ browserSessionId: newSessionId });
        } else {
          this.setState({ browserSessionId: existingSessionId });
        }

        // Handle tab ID - unique for each browser tab
        const newTabId = uuidv4();
        localStorage.setItem("browserTabId", newTabId);
        this.setState({ "browserTabId": newTabId });

        // alert("Tab Id"+newTabId)
        // alert("sessionId"+sessionId)

        let requestParams = {
          "browser_tab_id": newTabId, // DQ Tab
          "session_id":sessionId, // Team Id
          "tenant_id":this.state.teamId, // Team Id
          "user_id":this.state.userId,
          "menu_type": "monitor"
        }
        addUserTracking(requestParams)
        // Cleanup when tab is closed
        window.addEventListener("beforeunload", this.handleTabClose);
    //  if (this.state.selectedTab !== "VERTICAL")   {
      try {
          let watchListResponse = await this.getLatestEnvironmentResponse();  
          if (!watchListResponse) {
            this.setState({ errorOccurred: true });
          } else if (watchListResponse.response.env_details) {
            let env = watchListResponse.response.env_details
          let latestEnvId = watchListResponse.response.latest_env_id;
          // const rawEnvId = this.props.location?.state?.data?.env_id;
          // const redirectEnvId = (rawEnvId !== undefined && rawEnvId !== null && rawEnvId !== "") ? Number(rawEnvId) : null;
          // const preferredEnvId = redirectEnvId !== null ? redirectEnvId : latestEnvId;

            const redirectEnvId = this.props.location?.state?.data?.env_id;
            // An incident must open in its own environment, rather than the
            // environment most recently used by the dashboard.
            let selectedEnv = redirectEnvId !== undefined && redirectEnvId !== null
              ? env.find(e => String(e.env_id) === String(redirectEnvId))
              : null;
            selectedEnv = selectedEnv || env.find(e => e.env_id === latestEnvId);
            let noData = false;

            if (!selectedEnv && latestEnvId === null) {
              selectedEnv = env[0];
              noData = true;
            } else if (!selectedEnv) {
              // Redirect env not found — fall back to latest, then first
              selectedEnv = env.find(e => Number(e.env_id) === Number(latestEnvId)) || env[0];
            }

                if (selectedEnv && selectedEnv.is_integrations === false) {
                  noData = true;
                }

                if (selectedEnv) {
                            this.setState({ 
                selectedEnvId: selectedEnv.env_id,
                selectedEnvName: selectedEnv.env_name,
                envList: env,
                noData:noData,                
                loader: false,
              });
            }
            else {
              this.setState({ noData: noData, loader: false });
            }
          }
        } catch (error) {
          console.error("Error fetching environment data:", error);      
          this.setState({ errorOccurred: true });
        }
      // }
      // else if (selectedEnv && !selectedEnv.is_integrations) {
      //     throw new Error("Environment has is_integrations set to false.");
      // } else {
      //     throw new Error("Environment with the specified latest_env_id not found.");
      // }
      }
  

  componentWillUnmount() {
   // alert("call post clear")
    let requestParams = {
      "browser_tab_id": this.state.browserTabId, // DQ Tab
      "session_id":this.state.browserSessionId, // Team Id
      "tenant_id":this.state.teamId, // Team Id
      "user_id":this.state.userId
    }
    deleteUserTracking(requestParams)
    window.removeEventListener("beforeunload", this.handleTabClose);
    document.body.style.overflow = "auto";

  }

  handleTabClose = () => {
    localStorage.removeItem("browser_tab_id");
  };

  drxReport(){
        document.body.classList.add("overflow-hidden");
        this.setState({
            isDrxReportFullscreenMode:true,
            DrxReportFullScreenClassKey:"show",
            DrxReportName:"testing"
        });
    }

 

    closedrxReportfullscreen(){
        document.body.classList.remove("overflow-hidden");
        this.setState({isDrxReportFullscreenMode:false,DrxReportFullScreenClassKey:""});
    }

async handleTabSelection(e) {
  const selectedTabName = e.currentTarget.getAttribute("data-name");
  if (!selectedTabName || selectedTabName === this.state.selectedTab) {
    return;
  }
  sessionStorage.removeItem("selectedWatchlist");
  sessionStorage.removeItem("selectedPipelineWatchlist");
  sessionStorage.setItem("realtimeSelectedTab", selectedTabName);
  this.setState(
    {
      selectedTab: selectedTabName,
      loader: true,
      noData: true,
      errorOccurred: false,
      redirectData: null,
    },
    async () => {
      try {
        const watchListResponse = await this.getLatestEnvironmentResponse();
        const response = watchListResponse?.response;
        const env = response?.env_details;

        if (!Array.isArray(env)) {
          this.setState({ errorOccurred: true, loader: false });
          return;
        }

        const findEnvironment = (envId) =>
          envId !== undefined && envId !== null && envId !== ""
            ? env.find((item) => String(item.env_id) === String(envId))
            : undefined;
        const selectedEnv = findEnvironment(response.latest_env_id) || env[0];
        const noData =
          !selectedEnv || selectedEnv.is_integrations === false;

        this.setState({
          selectedEnvId: selectedEnv?.env_id ?? "",
          selectedEnvName: selectedEnv?.env_name ?? "",
          envList: env,
          noData,
          loader: false,
        });
      } catch (error) {
        console.error("API call failed:", error);
        this.setState({ errorOccurred: true, loader: false });
      }
    }
  );
}

  callbackEnvironemnt(pmtest){
    this.setState({ 
      selectedEnvId: pmtest.value,
      selectedEnvName:pmtest.label,
      redirectData: null,
      noData: false,
      errorOccurred: false,
    });
  }

  render() {

    // const { location } = this.props;
    let data = this.state.redirectData;

//     console.log(JSON.stringify(data));
// console.log("this.state.envList",this.state.envList);

    let {browserSessionId,browserTabId,selectedTab,selectedEnvId,selectedEnvName,teamId,userId} = this.state;
   if (data && Object.keys(data).length > 0) {
    if (data.env_id && !selectedEnvId) {
      selectedEnvId = Number(data.env_id);
    }
    if (data.menu_type === 'VERTICAL') {
      selectedTab = 'VERTICAL';
    } else if (data.type && selectedTab === "DQ") {
      selectedTab = data.type;
    }
  }

  const matchedEnv = Array.isArray(this.state.envList) && this.state.envList.find(env => env.env_id === selectedEnvId);
  if (matchedEnv && !this.state.selectedEnvName) {
    selectedEnvName = matchedEnv.env_name;
  }

  // Use state values directly to ensure props update when state changes
  selectedEnvId = this.state.selectedEnvId || selectedEnvId;
  selectedEnvName = this.state.selectedEnvName || selectedEnvName;

// let featureAccess = getFeatureAccess()
// let enableDQReportsTab = false;
// if (!IS_NONE_CHECK.includes(featureAccess)) {
//             const DQReportsTab = featureAccess["dq-reports"];
//             enableDQReportsTab = DQReportsTab === true;
// }


  return (
      <>
              <NavigationHeader
               selectedEnvId={selectedEnvId}
               selectedEnvName={selectedEnvName}
               envList={this.state.envList} 
               page="realtime"
               cachenable = {true}
               callbackEnvironemnt={this.callbackEnvironemnt}
              />
        <main>
        <div className="qd-rt_wrap rt-pipeline-wrap">
            {/* layout Menu */}
            <div className="qd-rt_menu">
              <ul className="qd-rt_menu-list">
                <li className={this.state.selectedTab==="DQ" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="DQ" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Data Quality Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.2 14.294C18.8425 14.4792 18.4438 14.646 18.0126 14.7912C16.3765 15.3421 14.2141 15.6364 12 15.6364C9.78589 15.6364 7.62352 15.3421 5.9874 14.7912C5.55624 14.646 5.15753 14.4792 4.8 14.294V18.3654C4.80021 18.3667 4.80058 18.3694 4.80176 18.3734C4.80445 18.3825 4.812 18.4015 4.829 18.4302C4.8648 18.4905 4.93939 18.5839 5.08125 18.6992C5.37025 18.934 5.85327 19.1929 6.55693 19.4299C7.9589 19.9019 9.91761 20.1818 12 20.1818C14.0824 20.1818 16.0411 19.9019 17.4431 19.4299C18.1467 19.1929 18.6297 18.934 18.9187 18.6992C19.0606 18.5839 19.1352 18.4905 19.171 18.4302C19.188 18.4015 19.1956 18.3825 19.1982 18.3734C19.1994 18.3694 19.1998 18.3667 19.2 18.3654V14.294ZM19.2 7.93129C18.8388 8.11793 18.4386 8.2841 18.0126 8.42756C16.4326 8.95956 14.3066 9.27273 12 9.27273C9.69343 9.27273 7.56744 8.95956 5.9874 8.42756C5.56136 8.2841 5.16123 8.11793 4.8 7.93129V12.0018C4.80021 12.0031 4.80058 12.0057 4.80176 12.0098C4.80445 12.0189 4.812 12.0379 4.829 12.0666C4.8648 12.1269 4.93939 12.2203 5.08125 12.3356C5.37025 12.5704 5.85327 12.8293 6.55693 13.0662C7.9589 13.5383 9.91761 13.8182 12 13.8182C14.0824 13.8182 16.0411 13.5383 17.4431 13.0662C18.1467 12.8293 18.6297 12.5704 18.9187 12.3356C19.0606 12.2203 19.1352 12.1269 19.171 12.0666C19.188 12.0379 19.1956 12.0189 19.1982 12.0098C19.1994 12.0057 19.1998 12.0031 19.2 12.0018V7.93129ZM19.1974 5.62216C19.1943 5.61198 19.1863 5.5923 19.1684 5.56268C19.1302 5.49986 19.0522 5.40533 18.9064 5.28924C18.6093 5.05269 18.1235 4.79925 17.4431 4.57014C16.0915 4.11506 14.1669 3.81818 12 3.81818C9.83306 3.81818 7.90851 4.11506 6.55693 4.57014C5.87646 4.79925 5.39071 5.05269 5.09355 5.28924C4.94777 5.40533 4.86982 5.49986 4.83164 5.56268C4.81366 5.5923 4.80573 5.61198 4.80264 5.62216C4.7998 5.63157 4.8 5.6357 4.8 5.63636C4.8 5.63703 4.7998 5.64116 4.80264 5.65057C4.80573 5.66075 4.81366 5.68043 4.83164 5.71005C4.86982 5.77287 4.94777 5.8674 5.09355 5.98349C5.39071 6.22004 5.87646 6.47347 6.55693 6.70259C7.90851 7.15767 9.83306 7.45455 12 7.45455C14.1669 7.45455 16.0915 7.15767 17.4431 6.70259C18.1235 6.47347 18.6093 6.22004 18.9064 5.98349C19.0522 5.8674 19.1302 5.77287 19.1684 5.71005C19.1863 5.68043 19.1943 5.66075 19.1974 5.65057C19.2002 5.64116 19.2 5.63703 19.2 5.63636C19.2 5.6357 19.2002 5.63157 19.1974 5.62216ZM21 18.3636C21 19.1139 20.5564 19.7013 20.0473 20.1152C19.5299 20.5358 18.8275 20.8804 18.0126 21.1548C16.3765 21.7057 14.2141 22 12 22C9.78589 22 7.62352 21.7057 5.9874 21.1548C5.17248 20.8804 4.47015 20.5358 3.95273 20.1152C3.44356 19.7013 3 19.1139 3 18.3636V5.63636C3 4.86198 3.46673 4.26873 3.9791 3.8608C4.50164 3.44483 5.20221 3.10957 5.9874 2.84517C7.56744 2.31317 9.69343 2 12 2C14.3066 2 16.4326 2.31317 18.0126 2.84517C18.7978 3.10957 19.4984 3.44483 20.0209 3.8608C20.5333 4.26873 21 4.86198 21 5.63636V18.3636Z" fill="currentColor" />
                        </svg>
                      </div>
                </RcTooltip>
                <span className='qd-rt_menu-label'>Data</span>
                </li>
                {/* <li className={this.state.selectedTab==="MODEL" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="MODEL" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Data Model Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2C12.4724 2 12.9361 2.12611 13.3456 2.36402L13.3465 2.36314L19.6465 5.99982L19.65 6.00249C20.06 6.24163 20.401 6.58551 20.6379 6.99956C20.8747 7.41357 20.9995 7.88338 21 8.36154V15.6367C20.9995 16.1149 20.8747 16.5846 20.6379 16.9987C20.401 17.4127 20.06 17.7566 19.65 17.9957L19.6465 17.9984L13.3465 21.6351L13.3456 21.6342C12.9641 21.8558 12.5356 21.9788 12.0967 21.9947C12.0649 21.9981 12.0327 22 12 22C11.967 22 11.9345 21.9982 11.9024 21.9947C11.4636 21.9786 11.0349 21.8559 10.6535 21.6342V21.6351L4.35352 17.9984L4.35 17.9957C3.93999 17.7566 3.59904 17.4127 3.36211 16.9987C3.12526 16.5846 3.00049 16.1149 3 15.6367V8.36154L3.00615 8.18219C3.03368 7.76645 3.15497 7.3617 3.36211 6.99956C3.59903 6.58551 3.94003 6.24163 4.35 6.00249L4.35352 5.99982L10.6535 2.36314V2.36402C11.0632 2.12586 11.5273 2 12 2ZM4.8 15.6349L4.80791 15.7539C4.82341 15.8714 4.86134 15.9853 4.92041 16.0886C4.99869 16.2254 5.11142 16.3393 5.24648 16.4189L11.1 19.7972V12.5247L4.8 8.86762V15.6349ZM12.9 12.5247V19.7972L18.7535 16.4189C18.8886 16.3393 19.0013 16.2254 19.0796 16.0886C19.1583 15.951 19.1997 15.7947 19.2 15.6358V8.86762L12.9 12.5247ZM12 3.81834C11.842 3.81834 11.6868 3.86021 11.55 3.93998L11.5465 3.94176L5.72021 7.30409L12 10.9497L18.2789 7.30409L12.4535 3.94176L12.45 3.93998C12.3132 3.86021 12.158 3.81834 12 3.81834Z" fill="currentColor" />
                        </svg>
                      </div>
                  </RcTooltip>
                </li>  */}
                <li className={this.state.selectedTab==="PIPELINE" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="PIPELINE" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Pipeline Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M3.81818 16.5455V20.1818H7.45455V16.5455H3.81818ZM16.5455 16.5455V20.1818H20.1818V16.5455H16.5455ZM10.1818 3.81818V7.45455H13.8182V3.81818H10.1818ZM15.6364 7.45455C15.6364 8.4587 14.8223 9.27273 13.8182 9.27273H12.9091V11.0909H17.4545C17.9368 11.0909 18.3991 11.2826 18.7401 11.6236C19.081 11.9646 19.2727 12.4269 19.2727 12.9091V14.7273H20.1818C21.186 14.7273 22 15.5413 22 16.5455V20.1818C22 21.186 21.186 22 20.1818 22H16.5455C15.5413 22 14.7273 21.186 14.7273 20.1818V16.5455C14.7273 15.5413 15.5413 14.7273 16.5455 14.7273H17.4545V12.9091H6.54545V14.7273H7.45455C8.4587 14.7273 9.27273 15.5413 9.27273 16.5455V20.1818C9.27273 21.186 8.4587 22 7.45455 22H3.81818C2.81403 22 2 21.186 2 20.1818V16.5455C2 15.5413 2.81403 14.7273 3.81818 14.7273H4.72727V12.9091C4.72727 12.4269 4.91897 11.9646 5.25994 11.6236C5.60092 11.2826 6.06324 11.0909 6.54545 11.0909H11.0909V9.27273H10.1818C9.17766 9.27273 8.36364 8.4587 8.36364 7.45455V3.81818C8.36364 2.81403 9.17766 2 10.1818 2H13.8182C14.8223 2 15.6364 2.81403 15.6364 3.81818V7.45455Z" fill="currentColor"/>
                        </svg>
                      </div>
                </RcTooltip>
                <span className='qd-rt_menu-label'>Pipeline</span>
                </li>
                <li className={this.state.selectedTab==="VERTICAL" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="VERTICAL" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Verticalization</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20.1818 15.3776C17.6702 16.7019 14.8622 17.4026 12 17.4026C9.13776 17.4026 6.32982 16.7019 3.81818 15.3776V18.3C3.81818 18.7971 4.2252 19.2 4.72727 19.2H19.2727C19.7748 19.2 20.1818 18.7971 20.1818 18.3V15.3776ZM12.0089 12C12.511 12 12.918 12.4029 12.918 12.9C12.918 13.3971 12.511 13.8 12.0089 13.8H12C11.4979 13.8 11.0909 13.3971 11.0909 12.9C11.0909 12.4029 11.4979 12 12 12H12.0089ZM20.1818 9.3C20.1818 8.80294 19.7748 8.4 19.2727 8.4H4.72727C4.2252 8.4 3.81818 8.80294 3.81818 9.3V13.3043C6.27535 14.8043 9.10693 15.6026 12 15.6026C14.8931 15.6026 17.7246 14.8043 20.1818 13.3043V9.3ZM14.7273 5.7C14.7273 5.46131 14.6314 5.23245 14.4609 5.06367C14.2904 4.89489 14.0593 4.8 13.8182 4.8H10.1818C9.94071 4.8 9.70955 4.89489 9.53906 5.06367C9.36858 5.23245 9.27273 5.46131 9.27273 5.7V6.6H14.7273V5.7ZM16.5455 6.6H19.2727C20.779 6.6 22 7.80883 22 9.3V18.3C22 19.7912 20.779 21 19.2727 21H4.72727C3.22104 21 2 19.7912 2 18.3V9.3C2 7.80883 3.22104 6.6 4.72727 6.6H7.45455V5.7C7.45455 4.98392 7.74209 4.29736 8.25355 3.79102C8.76501 3.28467 9.4585 3 10.1818 3H13.8182C14.5415 3 15.235 3.28467 15.7464 3.79102C16.2579 4.29736 16.5455 4.98392 16.5455 5.7V6.6Z" fill="currentColor"/>
                        </svg>
                      </div>
                </RcTooltip>
                <span className='qd-rt_menu-label'>Vertical</span>
                </li>
              <div className="menu-divider"></div>
              <li className={this.state.selectedTab === "REPORT" ? "qd-rt_menu-item active" : "qd-rt_menu-item"} data-name="REPORT" onClick={this.drxReport}  // Call the handler on click
              >
              <RcTooltip
                placement="right"
                overlay={
                  <span>Report</span>
                }
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
              >
                  <div className="qd-rt_menu-icon report-icon tw-relative">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15 12H10M15 8H10M19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H4M4 3C4.53043 3 5.03914 3.21071 5.41421 3.58579C5.78929 3.96086 6 4.46957 6 5V8M4 3C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5V7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8H6M8 21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V18C22 17.7348 21.8946 17.4804 21.7071 17.2929C21.5196 17.1054 21.2652 17 21 17H11C10.7348 17 10.4804 17.1054 10.2929 17.2929C10.1054 17.4804 10 17.7348 10 18V19C10 19.5304 9.78929 20.0391 9.41421 20.4142C9.03914 20.7893 8.53043 21 8 21ZM8 21C7.46957 21 6.96086 20.7893 6.58579 20.4142C6.21071 20.0391 6 19.5304 6 19V8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span class="dot-circle !tw-w-[6px] !tw-h-[6px] !tw-absolute !tw-top-[4px] !tw-right-[2px] !tw-bg-[#FA4616] mr-1" style={{outline: '2px solid #fff'}}></span>
                </div>
                </RcTooltip>
                <span className='qd-rt_menu-label'>Report</span>
            </li>
                 {/* <li className={this.state.selectedTab==="ALERTS" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="ALERTS" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Alerts</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.8802 12.6479V9.47922C12.8802 9.22983 12.7958 9.02078 12.6271 8.85208C12.4584 8.68337 12.2494 8.59902 12 8.59902C11.7506 8.59902 11.5416 8.68337 11.3729 8.85208C11.2042 9.02078 11.1198 9.22983 11.1198 9.47922V12.978C11.1198 13.0954 11.1418 13.209 11.1858 13.3191C11.2298 13.4291 11.2958 13.5281 11.3839 13.6161L13.8484 16.0807C14.0098 16.2421 14.2152 16.3227 14.4645 16.3227C14.7139 16.3227 14.9193 16.2421 15.0807 16.0807C15.2421 15.9193 15.3227 15.7139 15.3227 15.4645C15.3227 15.2152 15.2421 15.0098 15.0807 14.8484L12.8802 12.6479ZM12 20.9218C10.8998 20.9218 9.86919 20.7127 8.90831 20.2946C7.94743 19.8765 7.11125 19.3117 6.39976 18.6002C5.68826 17.8888 5.12347 17.0526 4.70538 16.0917C4.28729 15.1308 4.07824 14.1002 4.07824 13C4.07824 11.8998 4.28729 10.8692 4.70538 9.90831C5.12347 8.94743 5.68826 8.11125 6.39976 7.39976C7.11125 6.68826 7.94743 6.12347 8.90831 5.70538C9.86919 5.28729 10.8998 5.07824 12 5.07824C13.1002 5.07824 14.1308 5.28729 15.0917 5.70538C16.0526 6.12347 16.8888 6.68826 17.6002 7.39976C18.3117 8.11125 18.8765 8.94743 19.2946 9.90831C19.7127 10.8692 19.9218 11.8998 19.9218 13C19.9218 14.1002 19.7127 15.1308 19.2946 16.0917C18.8765 17.0526 18.3117 17.8888 17.6002 18.6002C16.8888 19.3117 16.0526 19.8765 15.0917 20.2946C14.1308 20.7127 13.1002 20.9218 12 20.9218ZM3.24205 7.98288C3.08068 7.82152 3 7.61614 3 7.36675C3 7.11736 3.08068 6.91198 3.24205 6.75061L5.75061 4.24205C5.91198 4.08068 6.11736 4 6.36675 4C6.61614 4 6.82152 4.08068 6.98288 4.24205C7.14425 4.40342 7.22494 4.6088 7.22494 4.85819C7.22494 5.10758 7.14425 5.31296 6.98288 5.47433L4.47433 7.98288C4.31296 8.14425 4.10758 8.22494 3.85819 8.22494C3.6088 8.22494 3.40342 8.14425 3.24205 7.98288ZM20.7579 7.98288C20.5966 8.14425 20.3912 8.22494 20.1418 8.22494C19.8924 8.22494 19.687 8.14425 19.5257 7.98288L17.0171 5.47433C16.8557 5.31296 16.7751 5.10758 16.7751 4.85819C16.7751 4.6088 16.8557 4.40342 17.0171 4.24205C17.1785 4.08068 17.3839 4 17.6333 4C17.8826 4 18.088 4.08068 18.2494 4.24205L20.7579 6.75061C20.9193 6.91198 21 7.11736 21 7.36675C21 7.61614 20.9193 7.82152 20.7579 7.98288ZM12 19.1614C13.7164 19.1614 15.1724 18.5636 16.368 17.368C17.5636 16.1724 18.1614 14.7164 18.1614 13C18.1614 11.2836 17.5636 9.82763 16.368 8.63203C15.1724 7.43643 13.7164 6.83863 12 6.83863C10.2836 6.83863 8.82763 7.43643 7.63203 8.63203C6.43643 9.82763 5.83863 11.2836 5.83863 13C5.83863 14.7164 6.43643 16.1724 7.63203 17.368C8.82763 18.5636 10.2836 19.1614 12 19.1614Z" fill="currentColor"/>
                        </svg>
                      </div>
                  </RcTooltip>
                </li>
                <li className={this.state.selectedTab==="NOTIFICATION" ? "qd-rt_menu-item active": "qd-rt_menu-item"} id="rt_menu_notification" data-name="NOTIFICATION"  onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Notifications</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <g id="Group_5010" data-name="Group 5010" transform="translate(-87 -3903)">
                            <g id="bell_1_" data-name="bell (1)" transform="translate(88.82 3905)">
                              <path id="Path_1441" data-name="Path 1441" d="M17.545,14.911H2.816a.825.825,0,0,1-.8-.587.8.8,0,0,1,.338-.909,4.152,4.152,0,0,0,1.033-1.37A11.492,11.492,0,0,0,4.452,6.728a5.728,5.728,0,0,1,11.456,0,11.492,11.492,0,0,0,1.063,5.318A4.152,4.152,0,0,0,18,13.416a.8.8,0,0,1,.338.909A.825.825,0,0,1,17.545,14.911ZM4.574,13.275H15.786q-.093-.153-.187-.324a12.975,12.975,0,0,1-1.327-6.222,4.092,4.092,0,0,0-8.183,0,12.975,12.975,0,0,1-1.327,6.222Q4.668,13.122,4.574,13.275Z" fill="currentColor" />
                              <path id="Path_1442" data-name="Path 1442" d="M11.5,22.452A2.462,2.462,0,0,1,9.38,21.229a.818.818,0,0,1,1.416-.821.818.818,0,0,0,1.416,0,.818.818,0,0,1,1.416.821A2.462,2.462,0,0,1,11.5,22.452Z" transform="translate(-1.324 -3.452)" fill="currentColor" />
                            </g>
                            <g id="alarm_black_24dp" transform="translate(87 3903)">
                              <path id="Path_1426" data-name="Path 1426" d="M0,0H24V24H0Z" fill="none" />
                            </g>
                          </g>
                        </svg>
                        <span className="badge badge-alert">4</span>
                      </div>
                  </RcTooltip>
                </li>  */}
              </ul>
            </div>
            {

              this.state.loader === true  
              ?
                <div className="portlet w-100 h-100 d-flex align-items-center justify-content-center">
                  <div className="portlet-body">
                    <Load />
                  </div>
                </div>
              :

              (this.state.noData && (this.state.selectedTab === "DQ" || this.state.selectedTab === "VERTICAL")
              ? 
                <>
                    <NoDataComponent
                        noContentSubtext={"Please Configure datasource to view Real-time"}
                        customButtonName={"Configure Datasource"}
                        navigatePage={"/configure"}
                        realtime = {true}
                        noDataFound = {this.state.noData}
                        selectedTab = {this.state.selectedTab}/>
                </>
              :     
              (this.state.noData && this.state.selectedTab === "PIPELINE"
                &&         
                <>
                    <NoDataComponent
                      noContentSubtext={"Please Configure pipeline to view Real-time"}
                      customButtonName={"Configure Pipeline"}
                      navigatePage={"/pipeline"}
                      realtime = {true}
                      noDataFound = {this.state.noData}
                      selectedTab = {this.state.selectedTab}/>
                </>
                )
              )  
            }

{this.state.selectedTab === "VERTICAL" && this.state.noData === false && browserSessionId!==null && browserTabId!==null && selectedEnvId!==""  ?  <LoadRealTimeCompoent
              selectedTab={this.state.selectedTab}
              monitorModule = {this.props.monitorModuleProps}
              selectedEnvId={selectedEnvId}
              selectedEnvName={selectedEnvName}
              teamId={teamId}
              userId={userId}
              browserTabId={browserTabId}
              browserSessionId={browserSessionId}
              data={this.state.incidentData}
            /> : this.state.noData === false && browserSessionId!==null && browserTabId!==null && selectedEnvId!==""  ?
            <LoadRealTimeCompoent
              selectedTab={this.state.selectedTab}
              selectedEnvId={selectedEnvId}
              selectedEnvName={selectedEnvName}
              teamId={teamId}
              userId={userId}
              browserTabId={browserTabId}
              browserSessionId={browserSessionId}
              data={this.state.incidentData}
              selectedDate={this.state.incidentData?.date}
              integrationId={this.state.incidentData?.integration_id}
            /> : "" }
            <div className="rt-dropdown_backdrop"></div>
            <div className="qd-blur-loader: true"></div>  {/* Blur Loader - Add Show class */}
            {/* <AiAssistant /> */}
          </div>
        </main>


        {this.state.isDrxReportFullscreenMode ?
                            <DrxReportFullScreen fullScreenClassVal={this.state.DrxReportFullScreenClassKey}
                                                    title="Title"
                                                    key={"DrxReportFullScreen"}
                                                    closedrxReportfullscreen = {this.closedrxReportfullscreen}
                            >
                            </DrxReportFullScreen> : ''
                        }
      </>
    );
  }
}
